export const VariogramIcon = {
  name: 'Variogram',
  prefix: 'string',
  height: '24',
  width: '24',
  svgPathData:
    'M0 20V0h2v18h18v2H0ZM16.5 5a1 1 0 0 1-1 1c-4.607 0-7.05 2.153-8.393 4.39C5.722 12.697 5.5 15.133 5.5 15.5a1 1 0 1 1-2 0c0-.634.278-3.448 1.893-6.14C7.05 6.598 10.107 4 15.5 4a1 1 0 0 1 1 1ZM20 3h-2v4h2V3Zm-2 5v4h2V8h-2Zm0 5v4h2v-4h-2Zm2-13h-2v2h2V0Zm-3 0h-4v2h4V0Zm-5 0H8v2h4V0ZM7 0H3v2h4V0Z',
};
